import React, { useContext } from 'react';
import { SiteContext } from '../../../context/SiteContext';
import { TreeItemData } from '../../common/CommonTypes';
import { Link } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';

export const getFaqData = (): TreeItemData[] => {
  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandDisplayName, brandDisplayFullName, brandPhoneNumbers } = brand;

  const {
    quotesAndRenewalsNumber,
    changesAndComplaintsNumber,
    claimsNumber,
    glassHelplineNumber
  } = brandPhoneNumbers;

  const faqData: TreeItemData[] = [
    {
      id: 'H1',
      name: 'Driveaway Insurance',
      children: [
        {
          id: 'H1Q1',
          name: 'What is Driveaway Insurance?',
          children: [
            {
              id: 'H1A1',
              name: `Free Driveaway Insurance is temporary cover which expires at 23:59 hours the day after the policy start date. Customers who are purchasing a new or used ${brandDisplayName} and who are eligible for a quotation for Annual Insurance have the option to extend their Driveaway Insurance to 5 days. Terms, conditions and eligibility criteria apply.`,
              children: []
            }
          ]
        },
        {
          id: 'H1Q2',
          name: 'What are the differences in cover between Driveaway Insurance and Annual Insurance?',
          children: [
            {
              id: 'H1A2',
              name: (
                <>
                  They both provide comprehensive cover. There are some
                  differences
                  <Link
                    id='lnkCoverDetailsInText'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.CoverDetailsPage}>
                    click here for details
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H1Q3',
          name: 'What age limits apply?',
          children: [
            {
              id: 'H1A3',
              name: (
                <>
                  For Driveaway Insurance all drivers must be aged 21-79 years,
                  have a full UK driving licence held for at least 1 year,and
                  have been permanent UK residents for the last 3 years. For
                  Annual Insurance, all drivers must be aged 17-90.However,
                  acceptance criteria may vary by vehicle make/model and other
                  eligibility and underwriting criteria.All cover is subject to
                  the terms and conditions provided with the policy, the
                  <Link
                    id='lnkPolicyDocumentInText'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.PolicyDocuments}>
                    Policy Document
                  </Link>
                  and the
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    Terms of Business.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H1Q4',
          name: 'Can cover be in the name of a company/business?',
          children: [
            {
              id: 'H1A4',
              name: `Yes - you need to call ${quotesAndRenewalsNumber} to do this and the criteria is:• The owner of the vehicle must be the company• The policy holder must be the sole proprietor of the company• No other employees are permitted to drive`,
              children: []
            }
          ]
        },
        {
          id: 'H1Q5',
          name: 'Is business use covered?',
          children: [
            {
              id: 'H1A5',
              name: 'No - business use is only available with our Annual Insurance.',
              children: []
            }
          ]
        },
        {
          id: 'H1Q6',
          name: 'Can I add a second driver?',
          children: [
            {
              id: 'H1A6',
              name: `Yes, just call us on ${quotesAndRenewalsNumber}. The second driver must be must also meet our underwriting and eligibility criteria.`,
              children: []
            }
          ]
        },
        {
          id: 'H1Q7',
          name: 'Is foreign use covered?',
          children: [
            {
              id: 'H1A7',
              name: 'Yes – comprehensive EU cover is available.',
              children: []
            }
          ]
        },
        {
          id: 'H1Q8',
          name: 'What is the Excess?',
          children: [
            {
              id: 'H1A8',
              name: '£500',
              children: []
            }
          ]
        },
        {
          id: 'H1Q9',
          name: 'Do I need to have a tracking device fitted?',
          children: [
            {
              id: 'H1A9',
              name: 'For cover to be effective a Thatcham category S5 tracking device must be fitted and active for: pure electric vehicles valued over £60,000 petrol and diesel vehicles valued over £50,000',
              children: []
            }
          ]
        }
      ]
    },
    {
      id: 'H2',
      name: 'Free Excess Return Voucher',
      children: [
        {
          id: 'H2Q1',
          name: 'What is the Free Excess Return Voucher?',
          children: [
            {
              id: 'H2A1',
              name: (
                <>
                  The Free Excess Return Voucher allows you to reclaim either
                  the voucher value stated on your Excess Return Voucher or the
                  entire value of your excess (whichever is lower) if you need
                  to make an accident claim. The value of the Excess Return
                  Voucher can vary and is subject to change.Please click here to
                  see the
                  <Link
                    id='lnktermsAndConditionsInText'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.TermsAndConditions}>
                    terms and conditions
                  </Link>
                  .The Excess Return Voucher is valid for one year from its
                  start date and can only be used once. Only one voucher can be
                  issued per vehicle and is non-transferable. Only one voucher
                  can be redeemed per claim.
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H2Q2',
          name: 'How do I get it?',
          children: [
            {
              id: 'H2A2',
              name: `The Excess Return Voucher is available free of charge to retail customers who have purchased:• a new or used ${brandDisplayName} (excluding Motability and Commercial vehicles) from a ${brandDisplayName} authorised dealer.• a service, MOT or repair (subject to a minimum spend) from a ${brandDisplayName} authorised dealer.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q3',
          name: `Do I have to have an annual ${brandDisplayFullName} Insurance policy to get free Excess Return?`,
          children: [
            {
              id: 'H2A3',
              name: 'No.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q4',
          name: 'When can I use my voucher?',
          children: [
            {
              id: 'H2A4',
              name: `You may use your Excess Return Voucher if your vehicle suffers any damage covered under your insurance policy. Following an accident, you need to call ${brandDisplayName} Excess Return first on the dedicated ${claimsNumber} number, even before calling your insurer. The claim needs to be accepted and managed by ${brandDisplayName} Excess Return and the accident repair carried out at a ${brandDisplayName} Approved Bodyshop on the UK mainland.The voucher must be activated before the incident occurs and the incident must take place between the validity dates shown on the voucher.The voucher is not valid:• for standalone glass claims• for misfuelling claims• for Motability vehicles• if your vehicle is a total loss• if your insurer rejects your claim`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q5',
          name: 'Who is covered?',
          children: [
            {
              id: 'H2A5',
              name: 'The Excess Return voucher applies to the specified vehicle, so anyone who is insured to drive the vehicle can make an excess claim if they have an accident.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q6',
          name: 'What if I don’t want it?',
          children: [
            {
              id: 'H2A6',
              name: `You can cancel it by calling ${changesAndComplaintsNumber}.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q7',
          name: 'How long is the voucher for?',
          children: [
            {
              id: 'H2A7',
              name: 'The voucher is valid for one year.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q8',
          name: 'When does my voucher start?',
          children: [
            {
              id: 'H2A8',
              name: 'The start date and time will be shown on your voucher.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q9',
          name: 'Where is my Excess Return voucher?',
          children: [
            {
              id: 'H2A9',
              name: `It will be sent to you by email and again approximately 4 weeks later in a reminder email. If you don’t receive it, please call ${changesAndComplaintsNumber}.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q10',
          name: 'How much can I claim?',
          children: [
            {
              id: 'H2A10',
              name: 'You can make one claim up to the value of your voucher. For example, if your excess is £350 and your Excess Return Voucher is £250, making a claim will only cost you £100, saving you £250.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q11',
          name: 'Can I claim for a standalone glass repair or replacement?',
          children: [
            {
              id: 'H2A11',
              name: 'No.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q12',
          name: 'Can I claim for misfuelling?',
          children: [
            {
              id: 'H2A12',
              name: 'No.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q13',
          name: 'How do I make an Excess Return Voucher claim?',
          children: [
            {
              id: 'H2A13',
              name: `Regardless of who you are insured with, following an accident, you need to call ${brandDisplayName} Excess Return first ${claimsNumber} before you call your motor insurer, in order to have your excess charges reimbursed under Excess Return. Please note, if you call your insurer first we will not be able to reimburse you.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q14',
          name: 'Will I need to contact my insurer?',
          children: [
            {
              id: 'H2A14',
              name: `Once you call ${brandDisplayName} Excess Return first, we will liaise with your insurer on your behalf. If we need you to contact your insurer we will advise you of this.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q15',
          name: 'Where will my vehicle be repaired?',
          children: [
            {
              id: 'H2A15',
              name: `At a ${brandDisplayName} Approved Accident Repair Centre using ${brandDisplayName} Genuine Parts - this is providing you call ${brandDisplayName} Excess Return first before your insurer.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q16',
          name: 'Is it just for fault accidents?',
          children: [
            {
              id: 'H2A16',
              name: 'Yes - if an accident is your fault you will have to pay an excess and your insurer will not repay this to you. This is where Excess Return comes in as it enables you to reclaim the excess you have paid out, up to the value of your voucher.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q17',
          name: 'In the event of a fault accident my insurer will repay my excess won’t they?',
          children: [
            {
              id: 'H2A17',
              name: 'No - in the event of a fault accident your insurer WILL NOT pay back your excess - it is the cost of making the claim. This is where Excess Return comes in; as it enables you to reclaim the excess you have paid out, up to the value of your voucher.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q18',
          name: 'I’ve got GAP Insurance, so why would I need an Excess Return Voucher?',
          children: [
            {
              id: 'H2A18',
              name: 'GAP Insurance only applies if your vehicle is written-off, or stolen and not recovered. It doesn’t apply to vehicle accidents, where you will have to pay an excess for the repairs.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q19',
          name: 'What does it offer that I do not have with my own insurer?',
          children: [
            {
              id: 'H2A19',
              name: `As well as reimbursing your excess, it enables you to have your car repaired at a ${brandDisplayName} Approved Bodyshop, instead of your insurer’s recommended repairer. This ensures your vehicle is repaired to ${brandDisplayName} standards with genuine ${brandDisplayName} parts.`,
              children: []
            }
          ]
        },
        {
          id: 'H2Q20',
          name: 'What happens at the end of the year?',
          children: [
            {
              id: 'H2A20',
              name: 'A few weeks before your Free Excess Return Voucher is due to expire, we’ll contact you to offer you a no-obligation Excess Return Policy and we’ll confirm the price.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q21',
          name: 'What happens if I make a claim – will the Excess Return Voucher end?',
          children: [
            {
              id: 'H2A21',
              name: 'Yes – the Excess Return Voucher covers you for one claim. If you make a claim your Excess Return Voucher will end and you will have the option to purchase a no-obligation Excess Return Policy.',
              children: []
            }
          ]
        },
        {
          id: 'H2Q22',
          name: 'Where can I see the terms and conditions?',
          children: [
            {
              id: 'H2A22',
              name: (
                <>
                  <Link
                    id='lnktermsAndConditionsInText'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.TermsAndConditions}>
                    Click this link
                  </Link>
                  to see the Excess Return Voucher terms and conditions.
                </>
              ),
              children: []
            }
          ]
        }
      ]
    },
    {
      id: 'H3',
      name: 'Annual insurance',
      children: [
        {
          id: 'H3Q1',
          name: 'What age limits apply?',
          children: [
            {
              id: 'H3A1',
              name: (
                <>
                  All drivers must be aged 17-90 years, have a full UK/EU or
                  provisional driving licence, and have been permanent UK
                  residents for the last 3 years. However, acceptance criteria
                  may vary by vehicle make/model and other eligibility and
                  underwriting criteria, such as minimum No Claims Discount
                  years.All cover is subject to the terms and conditions
                  provided with the policy, the
                  <Link
                    id='lnkPolicyDocumentInText'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.PolicyDocuments}>
                    Policy Document
                  </Link>
                  and the
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    Terms of Business.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H3Q2',
          name: 'Do I need to be the registered keeper of the car to insure it?',
          children: [
            {
              id: 'H3A2',
              name: 'We can insure the policyholder, their spouse, common law or civil partner, or personal lease company as the registered keeper of the car.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q3',
          name: 'What type of cover can I get?',
          children: [
            {
              id: 'H3A3',
              name: 'Our comprehensive insurance covers you for accidental damage, fire, theft or malicious damage to your own car, as well as any damage you cause to other people and their property.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q4',
          name: 'Why do I have to tell you what I use my car for?',
          children: [
            {
              id: 'H3A4',
              name: 'We need to make sure that your policy covers the activities for which you use your vehicle. There are five ‘classifications of use’:',
              children: []
            },
            {
              id: 'H3Q4SQ1',
              name: 'Social Domestic & Pleasure (Excluding commuting):',
              children: []
            },
            {
              id: 'H3Q4SQ2',
              name: 'Use for social domestic & pleasure purposes only.',
              children: []
            },
            {
              id: 'H3Q4SQ3',
              name: 'Social Domestic & Pleasure (Including commuting):',
              children: []
            },
            {
              id: 'H3Q4SQ4',
              name: 'Use for social domestic & pleasure purposes including travel to and from permanent place of business.',
              children: []
            },
            {
              id: 'H3Q4SQ5',
              name: 'Social Domestic & Pleasure and Business Use - Policy Holder (Class 1):',
              children: []
            },
            {
              id: 'H3Q4SQ6',
              name: 'Use for social domestic & pleasure purposes including commuting, and use by the policyholder only in person for his/her own or employers business.',
              children: []
            },
            {
              id: 'H3Q4SQ7',
              name: 'Social Domestic & Pleasure and Business Use - Policy Holder & Spouse (Class 1):',
              children: []
            },
            {
              id: 'H3Q4SQ8',
              name: 'Use for social domestic & pleasure purposes including commuting, and use by the policyholder only in person for his/her own or employers business, and by the policyholders spouse or civil partner in person for his/her own or employers business.',
              children: []
            },
            {
              id: 'H3Q4SQ9',
              name: 'Social Domestic & Pleasure and Business Use (Class 2):',
              children: []
            },
            {
              id: 'H3Q4SQ10',
              name: 'Use for social, domestic and pleasure purposes including commuting, and personal business use by the policyholder and business use by all permitted named drivers.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q5',
          name: 'What is a policy excess?',
          children: [
            {
              id: 'H3A5',
              name: `This is the amount that you agree to pay if you make a claim – your ${brandDisplayFullName} Insurance policy covers you for the remaining amount. Details can be found on your Policy Schedule. You should get the excess back if you are involved in a non-fault accident.`,
              children: []
            }
          ]
        },
        {
          id: 'H3Q6',
          name: 'What type of driver licences do you accept?',
          children: [
            {
              id: 'H3A6',
              name: 'UK full (including automatic licences) UK provisional (as long as there is another driver on the policy who is over 21 and has held a full licence for three years)',
              children: []
            }
          ]
        },
        {
          id: 'H3Q7',
          name: 'How can I pay?',
          children: [
            {
              id: 'H3A7',
              name: 'By credit card, debit card or monthly direct debit.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q8',
          name: 'If I pay by monthly direct debit, how does it work?',
          children: [
            {
              id: 'H3A8',
              name: (
                <>
                  Paying monthly is a finance option. As this is a credit
                  facility which is subject to status, we will submit an
                  application on your behalf to our finance lender, Premium
                  Credit Limited (PCL). If your application is successful, your
                  premium, which includes our arrangement fee, and any
                  additional products, will be paid for you by PCL. You will
                  then pay the agreed monthly instalments directly to PCL. In
                  this scenario, we act as a credit broker only and whilst we do
                  not charge a fee for introducing you, we do receive commission
                  from PCL for our credit broking arrangements with our
                  customers. For more information, you can view our Terms of
                  Business
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    here.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H3Q09',
          name: 'How much more will it cost if I choose to pay by monthly direct debit?',
          children: [
            {
              id: 'H3A09',
              name: (
                <>
                  Paying monthly is a credit facility so you will pay your total
                  premium including our arrangement fee and any additional
                  products plus interest and credit fees. For new customers, you
                  will be required to pay 10% of your total premium up front as
                  a deposit. The remainder of your premium will then be subject
                  to interest and is re-paid over 10 monthly instalments. For
                  renewing customers, no deposit is required so your total
                  premium will be subject to interest and re-paid over 11
                  monthly instalments. Our interest rates are subject to change,
                  so please contact our Customer Service team for our current
                  rates. For more information about the fees applicable, you can
                  view our Terms of Business
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    here.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H3Q10',
          name: 'Will paying monthly affect my credit rating?',
          children: [
            {
              id: 'H3A10',
              name: (
                <>
                  As paying monthly is a credit facility and subject to status,
                  the application for it will leave a footprint on your credit
                  profile which can be seen by other lenders who may use this
                  information to assess future applications. Missed or late
                  payments and defaults will also show on your credit profile,
                  and this may affect your future ability to obtain credit. For
                  more information, you can view our Terms of Business
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    here.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },

        {
          id: 'H3Q11',
          name: 'What happens if my application to pay monthly is declined?',
          children: [
            {
              id: 'H3A11',
              name: (
                <>
                  If your application for premium finance is declined, both we
                  and Premium Credit Limited will contact you. In the event this
                  happens, you will need to pay for your insurance in full
                  immediately. If you choose not to continue with the insurance
                  policy, you will still be required to pay for your time
                  insured. For more information, you can view our Terms of
                  Business
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    here.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H3Q12',
          name: 'What happens to my policy if the monthly direct debit agreement is cancelled?',
          children: [
            {
              id: 'H3A12',
              name: (
                <>
                  If your finance agreement with Premium Credit Limited is
                  cancelled, regardless of who invoked it, you will be liable to
                  pay for any outstanding costs. The costs and amounts due will
                  vary dependant on whether the agreement is cancelled during
                  the “cooling off” period (14 days from commencement) or after.
                  For more information, you can view our Terms of Business
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    here.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H3Q13',
          name: 'What is your policy on car modifications?',
          children: [
            {
              id: 'H3A13',
              name: '• Vehicle manufacturer parts and accessories Parts and accessories that are supplied by the vehicle manufacturer as a factory fitted option or sold and fitted by a vehicle manufacturer authorised bodyshop as part of the vehicle manufacturer’s official range are covered as standard. If they are fitted as an aftermarket update or addition to the vehicle, you will need to contact us for agreement. The value of the vehicle insured should reflect any options fitted. • Optional extras Optional extras are not treated as modifications as they are manufacturer fitted and are added as part of the vehicle sales process. If a vehicle is fitted with an optional extra when the vehicle is being purchased, this should be included within the vehicle’s overall value.Other than the above it will depend on the type of modification you have.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q14',
          name: 'Travelling abroad: Will my policy cover this?',
          children: [
            {
              id: 'H3A14',
              name: 'Your Annual Insurance includes free comprehensive cover in all EU countries. You will need to take your Certificate of Motor Insurance with you. Driveaway Insurance does not provide cover for driving in the EU.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q15',
          name: 'How do I get a Green Card?',
          children: [
            {
              id: 'H3A15',
              name: `If you need to arrange a Green Card, just call Customer Services on ${quotesAndRenewalsNumber}.`,
              children: []
            }
          ]
        },
        {
          id: 'H3Q16',
          name: 'Does my policy allow me to drive someone else’s car?',
          children: [
            {
              id: 'H3A16',
              name: 'Your Annual Insurance provides Third Party cover to drive someone else’s car with their consent. Conditions apply – please refer to your Policy Document for full terms. Driveaway Insurance does not provide cover for driving someone else’s car.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q17',
          name: 'Is my car covered for another person to drive?',
          children: [
            {
              id: 'H3A17',
              name: 'Only if the person is named on your Certificate of Motor Insurance. Other drivers may be permanently or temporarily added to your Annual Insurance once the policy has started.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q18',
          name: 'Will I receive a courtesy car?',
          children: [
            {
              id: 'H3A18',
              name: `With ${brandDisplayFullName} Insurance you are entitled to a courtesy car when your vehicle is repaired at a ${brandDisplayName} Approved Accident Repair Centre.`,
              children: []
            }
          ]
        },
        {
          id: 'H3Q19',
          name: 'Do I need to have a tracking device fitted?',
          children: [
            {
              id: 'H3A19',
              name: 'Vehicles valued over £50,000 must have a Thatcham accredited Category S5 tracking device fitted and active for cover to be effective.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q20',
          name: 'Why do you ask about convictions?',
          children: [
            {
              id: 'H3A20',
              name: 'This is an underwriting question to assess the risk to be incurred by the applicant(s).',
              children: []
            }
          ]
        },
        {
          id: 'H3Q21',
          name: 'Can the vehicle be kept overnight at a different address from that on the policy?',
          children: [
            {
              id: 'H3A21',
              name: 'No.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q22',
          name: 'Do you do ‘Any Driver’ policies?',
          children: [
            {
              id: 'H3A22',
              name: 'No.',
              children: []
            }
          ]
        },
        {
          id: 'H3Q23',
          name: 'How do I make changes to my policy?',
          children: [
            {
              id: 'H3A23',
              name: `Call ${brandDisplayFullName} Insurance on ${changesAndComplaintsNumber} and tell us what you want to change.`,
              children: []
            }
          ]
        },
        {
          id: 'H3Q24',
          name: 'What admin fees apply to my policy?',
          children: [
            {
              id: 'H3A24',
              name: (
                <>
                  Please refer to the
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    Terms of Business.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: 'H3Q25',
          name: 'What if my circumstances alter during the year?',
          children: [
            {
              id: 'H3A25',
              name: `All you need to do is tell us of any change by calling us on ${changesAndComplaintsNumber}.`,
              children: []
            }
          ]
        },
        {
          id: 'H3Q26',
          name: 'How do I get a replacement certificate?',
          children: [
            {
              id: 'H3A26',
              name: `If you lose your Certificate of Motor Insurance, or it becomes defaced or destroyed, just call us on ${changesAndComplaintsNumber} and a duplicate certificate will be sent out to you.`,
              children: []
            }
          ]
        },
        {
          id: 'H3Q27',
          name: 'How do I cancel my policy?',
          children: [
            {
              id: 'H3A27',
              name: (
                <>
                  To cancel your policy please call us on $
                  {quotesAndRenewalsNumber}. Alternatively write to us at the
                  following address giving 7 days’ notice. $
                  {brandDisplayFullName} Insurance, Car Care Plan Ltd, Second
                  Floor, Aztec Centre, Aztec West, Bristol BS32 4TD.For details
                  of cancellation fees please see the
                  <Link
                    id='lnkTermsOfBusiness'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
                    Terms of Business.
                  </Link>
                </>
              ),
              children: []
            }
          ]
        }
      ]
    },
    {
      id: '4H',
      name: 'No claims discount',
      children: [
        {
          id: '4HQ1',
          name: 'What is No Claims Discount (NCD)?',
          children: [
            {
              id: '4HA1',
              name: 'Every year of claim-free driving earns you a discount off the cost of your insurance renewal. The maximum NCD we award is 9 years.',
              children: []
            }
          ]
        },
        {
          id: '4HQ2',
          name: 'What do I need to provide as proof of my NCD?',
          children: [
            {
              id: '4HA2',
              name: (
                <>
                  You will need to provide acceptable proof of your NCD within
                  21 days of the policy start date, quoting your name, policy
                  number and vehicle registration: Online:
                  <Link
                    id='lnkProofOfNCDInText'
                    className='in-text'
                    to={PageAbsolutePath.Insurance.ProofOfNcd}>
                    Click here
                  </Link>
                  or By email to:
                  <Link className='in-text' to='#'>
                    protexNCDproof@carcareplan.co.uk
                  </Link>
                  , By post to: {brandDisplayFullName} Insurance, Car Care Plan
                  Ltd, Second floor, Aztec Centre, Aztec West, Bristol BS32 4TD
                  Your NCD must have been earned on a standard UK private car
                  policy. If you have NCD from a non-UK insurance or another
                  type of cover, you must call us to obtain approval before
                  arranging the policy as we may be able to assist you. Please
                  see our{' '}
                  <a
                    className='in-text'
                    target='_blank'
                    href='docs/Guide to NCD.pdf'>
                    Guide to NCD
                  </a>{' '}
                  which outlines our NCD proof requirements for all types of
                  cover.
                </>
              ),
              children: []
            }
          ]
        },
        {
          id: '4HQ3',
          name: 'Can I protect my NCD?',
          children: [
            {
              id: '4HA3',
              name: `It may be possible to protect your NCD – please call ${quotesAndRenewalsNumber} for further details.`,
              children: []
            }
          ]
        }
      ]
    },
    {
      id: '5H',
      name: 'Making a claim',
      children: [
        {
          id: '5HQ1',
          name: 'How do I make a claim?',
          children: [
            {
              id: '5HA1',
              name: `Call our 24-hour claims helpline on ${claimsNumber}`,
              children: []
            }
          ]
        },
        {
          id: '5HQ2',
          name: 'How do I make a windscreen claim?',
          children: [
            {
              id: '5HA2',
              name: `Should your windscreen become damaged in any way you will need to call our Glass Helpline on ${glassHelplineNumber}. If the windscreen is replaced or repaired, you’ll have to pay an excess - please refer to your Policy Document for details. Neither windscreen replacement nor repair will affect your No Claims Discount. If you are claiming on your Driveaway Insurance policy, then the windscreen excess will be £500 for repair or replacement.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ3',
          name: 'What should I do if I am involved in an accident?',
          children: [
            {
              id: '5HA3',
              name: `However careful you are, accidents do happen. It’s your job to try and avoid them; it’s our job to sort out the consequences as quickly and painlessly as we possibly can. Following these rules will keep the process uncomplicated for you and us: 1. Don’t drive away. You must stop if any other person or animal has been hurt, or if any vehicle or property has been damaged.2. Call our Claims and Accident Helpline on ${claimsNumber} either from the scene of the accident or as soon as practically possible. We ask that you call us within 2 hours of the incident – even if you do not plan to make a claim. Any delay may increase claims costs and ultimately your next premium.3. Get the names, addresses and phone numbers of any drivers or pedestrians involved, as well as any witnesses. Ask drivers for the names of their insurers and their policy or certificate numbers.4. If you have a mobile phone with you and it is fitted with a camera, try and take photographs to support the positions of the vehicles and the extent of damage.5. Don’t admit blame or liability or make an offer of payment. If any of the other people involved do this, please tell us.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ4',
          name: 'Who repairs my car?',
          children: [
            {
              id: '5HA4',
              name: `${brandDisplayFullName} Insurance only uses ${brandDisplayName} Approved Accident Repair Centres to repair your ${brandDisplayName} to provide the highest level of service and quality of repairs for our customers. This maintains the full integrity, safety and will help to protect the residual value of your vehicle. The ${brandDisplayName} Approved Accident Repair Centre will also provide you with a free courtesy car for the duration of the repair. Each repair is carried out in accordance with your vehicle manufacturer’s technical standards, and the quality of the repair is guaranteed for 5 years. All replaced parts are manufacturer-approved.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ5',
          name: 'What happens if I want to use my own repairer?',
          children: [
            {
              id: '5HA5',
              name: `You may use a repairer of your own choice but doing so means that ${brandDisplayFullName} Insurance will be unable to guarantee the work and you will need to obtain an estimate for us to approve the repair before work can commence. You will also lose your right to a free courtesy car, if you are the ‘at fault’ party.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ6',
          name: 'Total loss. What exactly does this mean?',
          children: [
            {
              id: '5HA6',
              name: `If the cost of the repair is disproportionate to the value of the vehicle, ${brandDisplayFullName} Insurance may consider it to be beyond economic repair. This is referred to as a total loss.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ7',
          name: 'If my vehicle is a total loss what about settlement value?',
          children: [
            {
              id: '5HA7',
              name: `Your ${brandDisplayName} approved repairer and the ${brandDisplayFullName} Insurance engineer will inspect your vehicle. Following this, they will consult with you and place a value on the vehicle. The value will be based on the condition of the car before the incident took place including: the bodywork, mileage, interior and service history. Following the completion of the total loss report, ${brandDisplayFullName} Insurance will conduct industry database checks. These aim to safeguard policyholders against any possible fraud. Once completed, payment will be sent to you, subject to the deduction of any excess.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ8',
          name: 'What happens if my car is stolen?',
          children: [
            {
              id: '5HA8',
              name: `The first thing you should do is report the theft to the Police. Ensure that you obtain a crime reference number, which you should make a careful note of. Then contact us on ${claimsNumber}. We will take down the full details from you. After this, a number of insurance industry database checks will be carried out – these are designed to protect our customers from fraud. A personal claims advisor will discuss the claim with you. When our enquiries are successfully completed, an offer will be made to settle your claim.`,
              children: []
            }
          ]
        },
        {
          id: '5HQ9',
          name: 'Do I need to contact the Police after an incident involving my car?',
          children: [
            {
              id: '5HA9',
              name: 'You need to report any incident to the Police in the following circumstances:If the car is stolen If the car has been broken into If the car has been maliciously damaged If you are involved in a collision which causes damage or injury to any other person, vehicle, animal (being a horse, cattle, an ass, a mule, a sheep, a pig, a goat or a dog) or property.If you feel other illegal acts have taken place',
              children: []
            }
          ]
        },
        {
          id: '5H10',
          name: 'How long will it take to sort out my claim?',
          children: [
            {
              id: '5HA10',
              name: 'Each claim is different so we are unable to give you an exact timescale. We aim to settle claims as quickly as possible. When you report the incident to your personal claims advisor he/she will give you a better idea of the period involved.',
              children: []
            }
          ]
        },
        {
          id: '5HQ11',
          name: 'What happens in the claims process if the accident was not my fault?',
          children: [
            {
              id: '5HA11',
              name: 'We aim to have your car repaired, or a settlement to you if it is a total loss, as quickly as possible. During the repair period, you will receive a courtesy car for your use. We will aim to recover any outlay we have made on your behalf from the person responsible for the accident – providing we’re successful, the claim will not affect your No Claims Discount.',
              children: []
            }
          ]
        },
        {
          id: '5HQ12',
          name: 'What happens if the accident was my fault?',
          children: [
            {
              id: '5HA12',
              name: 'With comprehensive cover, a claims advisor will arrange the repairs to your vehicle (or an inspection if likely to be a total loss) and we will handle the other driver’s claim as quickly as possible. Any correspondence that you might receive from the other driver, or their insurers, should be forwarded to your personal claims advisor who will respond on your behalf. In the meantime you will be provided with a courtesy car for the duration of the repair.',
              children: []
            }
          ]
        },
        {
          id: '5HQ13',
          name: 'What if the other driver disputes the accident circumstances?',
          children: [
            {
              id: '5HA13',
              name: 'Your personal claims advisor will do their very best to persuade the other driver (or their insurer) that the accident was their fault by presenting them with all the facts gathered and the facts that you have provided. Your personal claims advisor will always fight your corner but, on occasion, if the facts do not fully support either driver’s version of the incident, everybody involved may have to take some responsibility. If this happens, your personal claims advisor will negotiate the best possible settlement.',
              children: []
            }
          ]
        },
        {
          id: '5HQ14',
          name: 'How does a claim affect my No Claims Discount (NCD)?',
          children: [
            {
              id: '5HA14',
              name: 'If the incident was not your fault and your underwriter makes a full recovery from the responsible person, your NCD will be unaffected. For fault claims, please refer to the NCD Step Back Procedure in your Policy Document.',
              children: []
            }
          ]
        }
      ]
    },
    {
      id: '6H',
      name: 'Renewing your cover',
      children: [
        {
          id: '6HQ1',
          name: 'What methods of payment do you accept for policy renewal?',
          children: [
            {
              id: '6HA1',
              name: `We accept payment by debit or credit card, or continuation of your existing direct debit. To change the way you pay for your policy, please call us on ${changesAndComplaintsNumber}.`,
              children: []
            }
          ]
        },
        {
          id: '6HQ2',
          name: 'Will my premium change at renewal?',
          children: [
            {
              id: '6HA2',
              name: 'We aim to keep your renewal premium as low as possible. If you have less than 9 years’ No Claims Discount and have not made a claim during your time with us, you’ll receive a further year’s No Claims Discount up to a maximum of 9. This will reduce your premium, but any rate increases that may have to be made during the year could mean your premium is higher than the previous year.',
              children: []
            }
          ]
        },
        {
          id: '6HQ3',
          name: 'If I’ve made a claim, how will it affect my renewal premium?',
          children: [
            {
              id: '6HA3',
              name: `If ${brandDisplayFullName} Insurance already knows about the claim before we post your renewal pack, your No Claims Discount entitlement will have already been amended and your renewal premium revised to take the claim into account. If you make a claim and we’ve already sent your renewal pack, we will have to amend your No Claims Discount entitlement and revise your premium. We will let you know what your new premium is as soon as you notify us about the claim.`,
              children: []
            }
          ]
        },
        {
          id: '6HQ4',
          name: 'Will my No Claims Discount (NCD) be affected if I’ve made a claim this year?',
          children: [
            {
              id: '6HA4',
              name: 'NCD is reduced for every claim you make in such cases where we don’t recover all of our costs. If you have not chosen to protect your No Claims Discount, a claim or claims will reduce the discount. Please see the Policy Document for more information. Also, you won’t get an extra year’s NCD when your policy is due for renewal.',
              children: []
            }
          ]
        },
        {
          id: '6HQ5',
          name: 'What if my No Claims Discount (NCD) is protected?',
          children: [
            {
              id: '6HA5',
              name: 'The first claim you make where your underwriter doesn’t recover all of their costs will not affect your No Claims Discount. However, any further claims may affect it – please refer to the NCD Step Back Procedure in your Policy Document.',
              children: []
            }
          ]
        },
        {
          id: '6HQ7',
          name: 'Can I protect my No Claims Discount (NCD) at renewal?',
          children: [
            {
              id: '6HA7',
              name: `It may be possible to protect your NCD – please call ${quotesAndRenewalsNumber} for further details.`,
              children: []
            }
          ]
        },
        {
          id: '6HQ8',
          name: 'How do I make a change to my policy from renewal?',
          children: [
            {
              id: '6HA8',
              name: `Call us on ${changesAndComplaintsNumber} and we will make the change for you.`,
              children: []
            }
          ]
        },
        {
          id: '6HQ9',
          name: 'What should I do if I’ve received a motoring conviction during the past year?',
          children: [
            {
              id: '6HA9',
              name: `Please call us immediately on ${changesAndComplaintsNumber} if you experience any of the following: • Penalty points • A disqualification• A ban• Or any other motoring conviction`,
              children: []
            }
          ]
        },
        {
          id: '6HQ10',
          name: 'What should I do if I’ve modified my car?',
          children: [
            {
              id: '6HA10',
              name: `Please call us on ${changesAndComplaintsNumber} if you have modified your car, as we don’t cover all modifications.`,
              children: []
            }
          ]
        },
        {
          id: '6HQ11',
          name: 'What should I do if I don’t want to renew?',
          children: [
            {
              id: '6HA11',
              name: `Please call us on ${quotesAndRenewalsNumber}.`,
              children: []
            }
          ]
        },
        {
          id: '6HQ12',
          name: 'How do I get proof of my No Claims Discount (NCD)?',
          children: [
            {
              id: '6HA12',
              name: 'Your NCD proof can be found in your renewal pack.',
              children: []
            }
          ]
        }
      ]
    }
  ];

  return faqData;
};
